import { useInProgressBooking } from '@/hooks/useInProgressBooking';
import { Button, Icons, Popover } from '@fleet/webshop-ui';
import type { FC } from 'react';
import { useState } from 'react';
import BookingExpiryContent from './BookingExpiryContent';

const InProgressBookingCart: FC = () => {
  const { bookingId, isValidating, countdown, handleCheckoutClick } =
    useInProgressBooking();
  const [isOpen, setIsOpen] = useState(false);

  if (!bookingId || isValidating) return;

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      placement="bottom end"
      offset={8}
      trigger={
        <Button
          variant="ghostLink"
          className="group flex gap-2"
          data-testid="in-progress-booking-cart"
        >
          <span className="relative">
            <Icons.shoppingCart />
            <span
              className="absolute right-[-2px] top-[-2px] h-2 w-2 rounded-full bg-error-text"
              aria-hidden="true"
            />
          </span>
        </Button>
      }
      content={
        <BookingExpiryContent
          countdown={countdown}
          onCheckoutClick={() => handleCheckoutClick(() => setIsOpen(false))}
          showCloseButton
          onClose={() => setIsOpen(false)}
        />
      }
      data-testid="in-progress-booking-popover"
      className={{ content: 'w-80 p-2' }}
    />
  );
};

export default InProgressBookingCart;
